<div [ngClass]="{even}" class="wrapper">
  <div class="description">
    <div (contextmenu)="onRightClick($event)" class="image">
      <div *ngIf="!img" class="no-photo">
        <mat-icon>photo_camera</mat-icon>
      </div>
      <img *ngIf="img" [src]="img" class="thumbImg" alt="" />
    </div>
    <div class="info">
      <h2>
        <a [routerLink]="['/product', product?.id]" target="_blank" class="article">{{
          product?.id
        }}</a>
        {{ product?.description }}
      </h2>
      <span class="brand">{{ product?.brand?.description }}</span>
      <div class="id_article">
        <span>{{ product?.article }}</span>
      </div>

      <app-product-stock-list [product]="product"></app-product-stock-list>
    </div>
  </div>
  <div class="action">
    <div class="buttons">
      <button
        type="button"
        mat-icon-button
        *ngIf="!productInCart()"
        (click)="addToCart()"
        color="primary"
      >
        <mat-icon>shopping_basket</mat-icon>
      </button>
      <mat-form-field *ngIf="productInCart()" appearance="outline" class="quanCatalogue">
        <mat-label>Кол-во</mat-label>
        <input
          matInput
          type="number"
          [formControl]="getProductCartControl()"
          (input)="changeCartQuan()"
          placeholder="Кол-во"
        />
        <button
          matSuffix
          mat-icon-button
          color="warn"
          aria-label="Удалить"
          type="button"
          (click)="removeFromCart()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div
      class="price"
      matTooltipPosition="left"
      [matTooltip]="supportService.formatMoney(product?.price)"
    >
      {{ supportService.formatMoney(product?.retail) }}
    </div>
  </div>
</div>
<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
></div>
<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="openAnalogies(item)">
      <mat-icon>open_in_new</mat-icon> Аналоги
    </button>
    <button mat-menu-item (click)="setNewPrice(item)"><mat-icon>edit</mat-icon> Новая цена</button>
    <button mat-menu-item (click)="updateName(item)">
      <mat-icon>edit</mat-icon> Изменить наименование
    </button>
    <button mat-menu-item (click)="addImage(item)">
      <mat-icon>image</mat-icon> Добавить изображение
    </button>
    <button mat-menu-item (click)="removeDouble(item)">
      <mat-icon>remove</mat-icon> Удалить двойноую карточку
    </button>
    <button mat-menu-item (click)="printPriceTag(item)">
      <mat-icon>sell</mat-icon> Распечатать ценник
    </button>
    <button mat-menu-item (click)="addBarcode(item)">
      <mat-icon>qr_code</mat-icon> Добавить штрих-код
    </button>
    <button mat-menu-item (click)="editProductInWarehouse(item)">
      <mat-icon>warehouse</mat-icon> Изменить адрес хранения
    </button>
    <button mat-menu-item (click)="openFolders(item)"><mat-icon>folder</mat-icon> Папки</button>
    <button mat-menu-item (click)="openProps(item)">
      <mat-icon>settings</mat-icon> Характеристики
    </button>
  </ng-template>
</mat-menu>
